import {
  Box,
  Tooltip as CTooltip,
  useMediaQuery,
  useTooltip,
} from '@chakra-ui/react';
import * as React from 'react';

const tooltipProps = {
  hasArrow: true,
  arrowShadowColor: '#eee',
  placement: 'top',
  bg: 'white',
  color: 'gray.800',
  boxShadow: 'floating',
  px: 3,
  py: 2,
  rounded: 'md',
  zIndex: 'tooltip',
};

const noop = () => {};

/**
 * @deprecated
 * We must eventually delete all such abominations and replace with a single loader from design system
 */
const Tooltip = ({ children, isTouchFriendly, ...rest }: any) => {
  const [isTouchDevice] = useMediaQuery('(hover: none)');
  const tooltip = useTooltip();

  return isTouchFriendly && isTouchDevice ? (
    <Box tabIndex={0} as={'span'} {...tooltip.getTriggerProps()} onClick={noop}>
      <CTooltip {...tooltipProps} {...rest} isOpen={tooltip.isOpen}>
        {children}
      </CTooltip>
    </Box>
  ) : (
    <CTooltip {...tooltipProps} {...rest}>
      {children}
    </CTooltip>
  );
};

export default Tooltip;
